import * as helper from './../../../../../VX/View/Assets/Js/helper';
import {initImprint} from "../../../Assets/JS/imprint_la";
import { counter } from './counter';
import { clickListener } from './Listeners/clickListener';
import { ladderclimb } from './Ladder/ladderClimb';
import { hideOverlay } from './Overlay/hideOverlay';

// Put your Javascript here - You can use ES2015 Javascript, because we use Webpack with Babel
require('./../Sass/base.scss');

// Require babel polyfill before anything else so stupid IE can handle modern stuff like Symbols etc.
if (!(global as any)._babelPolyfill) {
	require('babel-polyfill');
	helper.onDocumentLoaded(() => {
		// @ts-ignore
		const data = window.data_Click2Climb as HTMLElement,
		             lastCTA = document.getElementById('access-button');

		initImprint(helper.$('#impressumlink'), helper.$('#datenschutzlink'));
		counter();
		clickListener('climb', ladderclimb);
		clickListener('overlay-back', hideOverlay);

		helper.addClickListener(lastCTA, (e:MouseEvent) => {
			e.preventDefault();
			window.open(data.dataset.url1);
			window.location.href = data.dataset.url2!;
		})
	});
}
